var ObserverType;
(function (ObserverType) {
    ObserverType["STANDARD"] = "Standard";
    ObserverType["LITE"] = "Lite";
})(ObserverType || (ObserverType = {}));
export default ObserverType;
